export default [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'integer',
    width: 50
  },
  {
    dataField: 'quitacao_direta',
    caption: 'Quitação Direta',
    width: 120,
    cellTemplate: 'SouNTemplate'
  },
  {
    dataField: 'modalidade',
    caption: 'Descrição'
  },
  {
    caption: 'Ações',
    cellTemplate: 'acaoCell',
    width: 100
  }
]
